// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__33ToA","header":"MergedInvoice_header__1Tpm_"};